<h3 style="text-align:center;font-size:1.77rem;font-weight:500">
    Finiquitos
</h3>
<h3 style="text-align:center;font-size:0.90rem;font-weight:500">
    {{ trabajadorNombre ? trabajadorNombre : 'Nombre del Trabajador' }}
</h3>

<!-- Spinner de carga -->
<div *ngIf="loadingData" class="spinner-container">
    <mat-spinner diameter="50"></mat-spinner>
</div>

<!-- Tabla de datos -->
<table mat-table id="tabla" [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="!loadingData">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let element"> {{ element.id }} </td>
    </ng-container>

    <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef> FECHA </th>
        <td mat-cell *matCellDef="let element">{{ element.fecha }}</td>
    </ng-container>
    <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef> TOTAL </th>
        <td mat-cell *matCellDef="let element"> {{ element.total | currency: 'CLP' }} </td>
    </ng-container>
    <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef> ACCIONES </th>
        <td mat-cell *matCellDef="let element">
            <!-- <button (click)="Descargar(element.id)" mat-button class="button_color_primary"
                style="background-color:rgb(37, 199, 228)">
                <mat-icon style="color: white">search</mat-icon>
            </button> -->
            <p-button class="mr-2" (click)="Descargar(element.id)" icon="pi pi-search" styleClass="p-button-rounded p-button-primary p-button-text"></p-button>
            <!-- <button (click)="Borrar(element.id, true)" mat-raised-button color="warn">
                <mat-icon style="color: white">delete</mat-icon>
            </button> -->
            <p-button *ngIf="!isAuditor" class="mr-2" (click)="Borrar(element.id, true)" icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-text" ></p-button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
